<template>
  <!-- Global $dialog confirm: same look as the Sign Out popup (ConfirmLayout). Same events / callback as before;
       the icon shows only when the caller passes one. -->
  <div v-if="visible">
    <div id="modalDiscard" ref="self" class="modal fade modal-md show fxModal fxConfirm" tabindex="-1" aria-modal="true" role="dialog"
      style="display: block; background: #00000050">
      <div class="modal-dialog modal-dialog-centered mobile:!w-full mobile:!right-0 mobile:!px-3 tablet:px-0 tablet:!w-[450px] !absolute tablet:!right-4 !top-0 !m-0 h-full">
        <div class="modal-content">
          <div class="modal-body">
            <ConfirmLayout :title="title" :image="image" :button-text="buttonText" :closable="buttonText != 'Dismiss'"
              @close="hide" @confirm="confirm">
              {{ text }}
            </ConfirmLayout>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConfirmLayout from "@/components/confirmDialog/ConfirmLayout.vue";
import EventBus from "@/plugins/EventBus";
import { disableScroll, enableScroll } from "../../helpers/scrollHelper";
export default {
  components: { ConfirmLayout },
  data() {
    return {
      visible: false,
      title: "",
      text: "",
      image: null,
      // adding callback function variable
      onConfirm: {},
      buttonText: "Continue"
    };
  },

  mounted() {
    this.onShow = (params) => this.show(params);
    EventBus.on("show", this.onShow);
  },

  // a layout that re-mounts must not leave its old dialog listening: it opened a second time (scroll jumped to the top)
  beforeUnmount() {
    EventBus.off("show", this.onShow);
  },

  methods: {
    hide() {
      // a modal still open under this confirm keeps the page locked ($el is not the modal: comment / v-if root)
      const modalBelow = [...document.querySelectorAll('.modal.show')].some(m => m !== this.$refs.self);
      this.visible = false;
      if (modalBelow) return;
      document.documentElement.style.overflow = ''; // Reset HTML element
      document.documentElement.style.paddingRight = '0px';
      enableScroll()
    },
    confirm() {
      // a fast double click lands before the dialog is removed: run the callback once
      if (!this.visible) return;
      // we must check if this.onConfirm is function
      if (typeof this.onConfirm === "function") {
        // run passed function and then close the modal
        this.onConfirm();
        this.hide();
      } else {
        // we only close the modal
        this.hide();
      }
    },
    show(params) {
      // making modal visible
      this.visible = true;
      // setting title and text
      this.title = params.title;
      this.text = params.text;
      this.buttonText = params.buttonText ?? 'Continue'
      this.image = params.image;
      // setting callback function
      this.onConfirm = params.onConfirm;

      document.documentElement.style.overflow = 'hidden'; // Target HTML element
      disableScroll()
      if (window.innerWidth >= 992) {
        document.documentElement.style.paddingRight = '15px';
      } else {
        document.documentElement.style.paddingRight = '0px';
      }
    },
  },
};
</script>

<style>
.modals-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modals {
  background: #ffffff;
  box-shadow: 2px 2px 20px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
}

.discard-wrap {
  /* border-radius: 20px;  */
  box-shadow: 0 0 10px #fff;
  border: 0;
  padding: 1.5rem;
}

.discard-wrap .modal-header {
  border: none;
}

.continue-popup .modal-header .close {
  position: absolute;
  top: 30px;
  right: 30px;
  background: #ff5b01;
  opacity: 1;
  padding: 0;
  height: 27px;
  width: 27px;
  border-radius: 50px;
  color: #fff;
  box-shadow: 0 2px 3px #444;
  font-weight: 100;
}

.continue-popup .modal-header {
  padding: 0;
  border: none;
}

.continue-popup {
  border-radius: 12px;
  box-shadow: 0 0 10px #fff;
  border: none;
}

.contPopup h1 {
  color: #003087;
  font-size: 35px;
  font-weight: 600;
  text-shadow: 0 1px 3px #666;
  margin-top: -30px;
}

.contPopup p {
  color: #444;
  font-size: 20px;
}

.btnClose {
  position: absolute;
  background: none;
  right: 20px;
  top: 20px;
  padding: 0;
  border: none;
  border-radius: 50px;
  z-index: 9;
  font-weight: bold;
  z-index: 9999;
}

.btnClose img {
  width: 40px;
}

.modalBtn {
  padding: 0.6rem 1.5rem !important;
}

@media screen and (max-width: 767px) {}
</style>
